/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useState } from 'react';

import ConfirmationModal from 'src/components/confirmation-model';
import { useDropzone } from 'react-dropzone';

import BlankFile from 'src/assets/blank_file.png';
import Newfile from 'src/assets/new_file.png';
import Attention from 'src/assets/attention.png';
import { DocumentsCategory } from 'src/interfaces';
import documentsService from 'src/services/documents.service';
import { IDocument } from 'src/interfaces/document';
import { useTranslation } from 'react-i18next';
import { AlertAdapter, Loader } from 'pg-ui-library';

import { useQueryClient } from '@tanstack/react-query';
import {
  AttentionContainer,
  DocumentContainer,
  DocumentContainerFilled,
  DocumentContainerFilledItems,
  DocumentDragAndDropContainer,
  DocumentDragAndDropContainerOnDrop,
  FileLabel,
  TooltipText,
  TrashIcon,
} from '../styles';

interface IDocumentDropArea {
  documentCategory: DocumentsCategory;
  employeeDocument?: IDocument;
  multipleFiles?: boolean;
}

const DocumentDropArea: React.FC<IDocumentDropArea> = ({ documentCategory, employeeDocument, multipleFiles }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [doc, setDoc] = useState<IDocument>();
  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation();
  const queryClient = useQueryClient();

  useEffect(() => {
    setDoc(employeeDocument);
  }, [employeeDocument]);

  const formatSize = (size: number) => {
    const fileSize = size / 1024 / 1024; // in MiB
    return fileSize;
  };

  const validFileFormat = (file: File): boolean => {
    if (formatSize(file.size) > 100) {
      AlertAdapter(t('documents.invalidFileSize'), 'error');
      return false;
    }
    if (file.type !== 'application/pdf') {
      AlertAdapter(t('documents.invalidFileFormat'), 'error');
      return false;
    }

    return true;
  };

  const fileUploadHandler = async (file: File) => {
    if (!validFileFormat(file)) return;
    if (file) {
      setLoading(true);
      const fd = new FormData();
      fd.append('document', file, file.name || '');
      documentsService
        .upload(fd, documentCategory)
        .then(
          () => {
            queryClient.invalidateQueries({ queryKey: ['documents'] });
          },
          (e: Error) => {
            AlertAdapter(e.message, 'error');
          }
        )
        .finally(() => setLoading(false));
    }
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length <= 0) {
      return;
    }
    acceptedFiles.forEach(file => {
      fileUploadHandler(file);
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
    },
    multiple: multipleFiles,
    onDropRejected: () => {
      AlertAdapter(t('documents.invalidFileFormat'), 'error');
    },
  });

  const removeFile = () => {
    if (!doc?.id) return;
    setLoading(true);
    documentsService
      .deleteDocument(doc?.id)
      .then(
        () => {
          setDoc(undefined);
          queryClient.invalidateQueries({ queryKey: ['documents'] });
        },
        () => {
          AlertAdapter('Error removing file', 'error');
        }
      )
      .finally(() => setLoading(false));
  };

  const handleConfirm = () => {
    removeFile();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const downloadDocument = () => {
    if (doc?.id) {
      return documentsService.getDocumentDownloadLink(doc?.id);
    }
  };

  if (loading) {
    return (
      <DocumentContainer {...getRootProps()}>
        <Loader width="50%" height="fit-content" />
      </DocumentContainer>
    );
  }

  if (doc) {
    return (
      <DocumentContainerFilled>
        <DocumentContainerFilledItems>
          <div>
            <img src={BlankFile} />
          </div>
          <div>
            <a href={downloadDocument()} download target="_blank" rel="noreferrer">
              <span>{doc.fileName}</span>
            </a>
          </div>
        </DocumentContainerFilledItems>
        <DocumentContainerFilledItems>
          <AttentionContainer>
            <TooltipText>{`${t('documents.validThru')} ${doc.expiresIn}`}</TooltipText>
            <img src={Attention} />
          </AttentionContainer>
          <div>
            <TrashIcon onClick={() => setIsModalOpen(true)} />
          </div>

          <ConfirmationModal
            isOpen={isModalOpen}
            message="Are you sure want to remove the file?"
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        </DocumentContainerFilledItems>
      </DocumentContainerFilled>
    );
  }
  return (
    <DocumentContainer {...getRootProps()}>
      {isDragActive ? (
        <DocumentDragAndDropContainerOnDrop>
          <img src={Newfile} width={25} />
          <input {...getInputProps()} />

          <FileLabel>{t('documents.dragzone')}</FileLabel>
        </DocumentDragAndDropContainerOnDrop>
      ) : (
        <DocumentDragAndDropContainer>
          <img src={Newfile} width={25} />
          <input {...getInputProps()} />

          <FileLabel>{t('documents.dragzone')}</FileLabel>
        </DocumentDragAndDropContainer>
      )}
    </DocumentContainer>
  );
};

export default DocumentDropArea;
